<template>
  <b-container fluid class="listPage">
    <b-row class="justify-content-start">
      <b-col cols="4" sm="3" md="4" xl="2">
        <b-button class="btnFilter" :disabled="activateSpinner"
          @click="onRefresh()">
          <i class="fa-light fa-rotate-right fs-14px"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
      <b-col class="mb-3" cols="12" sm="12" md="12" xl="12">
      </b-col>
      <!--      <div class="ml-3 mt-xl-0 text-xl-center">-->
<!--        <b-button-group class="">-->
<!--          <b-button :variant="type === 0 ? 'primary btn-selected' : ''" @click="type = 0">{{ $t('common.routing.type_0') }}</b-button>-->
<!--          <b-button :variant="type === 1 ? 'primary btn-selected' : ''" @click="type = 1">{{ $t('common.routing.type_1') }}</b-button>-->
<!--        </b-button-group>-->
<!--      </div>-->
<!--      <div class="ml-3 mt-xl-0 text-xl-center">-->
<!--        <b-button-group class="">-->
<!--          <b-button :variant="role === 0 ? 'primary btn-selected' : ''" @click="role = 0">{{ $t('common.routing.role_0') }}</b-button>-->
<!--          <b-button :variant="role === 1 ? 'primary btn-selected' : ''" @click="role = 1">{{ $t('common.routing.role_1') }}</b-button>-->
<!--        </b-button-group>-->
<!--      </div>-->
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="canAddMessageRouting && !activateSpinner && demo">
        <b-button class="mr-3 justify-item-end responsive-button"
          @click="addMessageRouting" variant="primary">
          <i class="fa-light fa-plus "></i>
          <span v-if="entitiesType == 'rvm'">{{$t('common.routing.add_rvm')}}</span>
          <span v-if="entitiesType == 'requester'">{{$t('common.routing.add_corporate')}}</span>
          <span v-if="entitiesType == 'responder'">{{$t('common.routing.add_si')}}</span>
          <span v-if="entitiesType == 'decentralised'">{{$t('common.routing.add_si_decentralised')}}</span>
        </b-button>
      </b-col>
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="entitiesType == 'rvm' || entitiesType == 'requester'">
        <b-button class="mr-3 justify-item-end responsive-button"
          @click="getConfiguration('requester')" variant="primary">
          <span>{{ $t('common.routing.receiver') }}</span>
        </b-button>
      </b-col>
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="entitiesType == 'rvm' || entitiesType == 'responder'">
        <b-button class="mr-3 justify-item-end responsive-button"
          @click="getConfiguration('responder')" variant="primary">
          <span>{{ $t('common.routing.sender') }}</span>
        </b-button>
      </b-col>
      <b-col class="my-2" v-if="entitiesType != 'decentralised'" cols="4" lg="3" xl="3">
        <b-button class="justify-item-end responsive-button"
                  @click="addImportReferentiel" variant="primary"
                  :disabled="true">
          <i class="fa-light fa-plus "></i>
          <span>{{$t('common.routing.import_referentiel')}}</span>
        </b-button>
      </b-col>


      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="entitiesType == 'decentralised'">
        <b-button class="mr-3 justify-item-end responsive-button"
                  @click="getConfigurationS3('2', '1')" variant="primary">
          <span>{{ $t('common.routing.update_connector_stet') }}</span>
        </b-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="entitiesType == 'decentralised'">
        <b-button class="mr-3 justify-item-end responsive-button"
                  @click="getConfigurationS3('2', '2')" variant="primary">
          <span>{{ $t('common.routing.update_connector_entity') }}</span>
        </b-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="entitiesType == 'decentralised'">
        <b-button class="mr-3 justify-item-end responsive-button"
                  @click="getConfigurationS3('3', '2')" variant="primary">
          <span>{{ $t('common.routing.update_connector_cacp') }}</span>
        </b-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="entitiesType == 'decentralised'">
        <b-button class="mr-3 justify-item-end responsive-button"
                  @click="getConfigurationS3('3', '2', 'WEBSERVICE')" variant="primary">
          <span>{{ $t('common.routing.update_connector_notification') }}</span>
        </b-button>
      </b-col>

<!--      <b-row class="justify-content-start no-gutters">-->
<!--        <div class="text-xl-center">-->
<!--          <b-button-group class=" d-xl-inline-flex">-->
<!--            <b-button v-if="entitiesType == 'rvm' || entitiesType == 'requester'" class="config-buttons-title" @click="getConfiguration()">{{ $t('common.routing.receiver') }}</b-button>-->
<!--            <b-button v-if="entitiesType == 'rvm' || entitiesType == 'responder'" class="config-buttons-title" @click="getConfiguration()">{{ $t('common.routing.sender') }}</b-button>-->
<!--          </b-button-group>-->
<!--        </div>-->
<!--      </b-row>-->
<!--          <b-button class="mx-3" variant="secondary"-->
<!--                    @click="addMessageRouting"-->
<!--                    >-->
<!--            <i class="fa-light fa-plus"></i>-->
<!--            <span>{{$t('common.routing.add_message_routing')}}</span>-->
<!--          </b-button>-->
    </b-row>

    <br />
    <b-tabs nav-class="d-none">
      <b-tab :title="$t('common.routing.in')">
        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
              <b-table hover relative responsive
                v-if="messageRoutingIn.length"
                class="mt-3 table-striped"
                :items="messageRoutingIn"
                :fields="fields"
                selectable select-mode="single" @row-selected="seeDetails">
                <template #cell(RoutingType)="data">
                  <span v-if="data.item.MessageType == 0">DDV</span>
                  <span v-if="data.item.MessageType == 1">DDD</span>
                  <span v-if="data.item.MessageType == 2">DMA</span>
                  <span v-if="data.item.MessageType == 3">DMA_CACP</span>
                </template>
                <template #cell(ConfigType)="data">
                  <span>
                    {{ data.item.Configs[0].ConfigType === "NULL" ? data.item.Configs[1].ConfigType : data.item.Configs[0].ConfigType === data.item.Configs[1].ConfigType ? data.item.Configs[0].ConfigType : data.item.Configs[0].ConfigType + " / " + data.item.Configs[1].ConfigType}}
                    <!-- {{ data.item.Configs[0].ConfigType == data.item.Configs[1].ConfigType ? data.item.Configs[0].ConfigType : data.item.Configs[0].ConfigType +' / '+data.item.Configs[1].ConfigType }} -->
                  </span>
                </template>
                <template #cell(ConfigIn)="data" v-if="entitiesType == 'rvm' || entitiesType == 'requester'">
                  <span>
                   {{ data.item.Configs[0].ConfigName == '' ? '-' : data.item.Configs[0].ConfigName }}
                  </span>
                </template>
                <template #cell(ConfigOut)="data" v-if="entitiesType == 'rvm' || entitiesType == 'responder' || entitiesType == 'decentralised'">
                  <span >
                   {{ data.item.Configs[1].ConfigName == '' ? '-' : data.item.Configs[1].ConfigName }}
                  </span>
                </template>
                <template #cell(Active)="data">
                  <span >
                   {{ data.item.Active == '1' ? $t('common.routing.active_1') : $t('common.routing.active_0')}}
                  </span>
                </template>
              </b-table>

              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>

import Spinner from '@/components/common/spinner.vue'
import Pagination from '@/components/common/pagination.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageList',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner
  },
  props: {
    roleFromURL: {
      type: String,
      default: '0'
    },
    typeFromURL: {
      type: String,
      default: '0'
    },
    entitiesType: {
    },
    tabName: {
    },
  },
  computed: {
    canAddMessageRouting () {
      return this.$engine.rights.rightIs('messageRoutingConfig_add', true)
    },
    fields () {
      let field
      if (this.entitiesType === 'requester') {
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigIn', label: this.$t('common.routing.connector_name_receiver'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
      }
      else if (this.entitiesType === 'responder') {
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigOut', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
      }
      else if (this.entitiesType === 'decentralised') {
        field =  [
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ConfigOut', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
      }
      else{
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          // { key: 'RoutingDescription', label: this.$t('common.desc'), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigIn', label: this.$t('common.routing.connector_name_receiver'), class: 'text-center table-condensed' },
          { key: 'ConfigOut', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
          // { key: 'ConfigTypeSender', label: this.$t('common.routing.config_type_sender'), class: 'text-center table-condensed' },
          // { key: 'ConfigNameSender', label: this.$t('common.routing.config_name_sender'), class: 'text-center table-condensed' },
        ]
      }
      return field
    },
  },
  data () {
    return {
      activateSpinner: false,
      messageRoutingIn: [],
      messageRoutingOut: [],
      pageCounter: 0,
      paginationObject: {},
      role: 0,
      type: 0,
      entityType: 0,
      demo: true,
      tabNameSelected: 'Corporate'
    }
  },
  created () {
    if (this.tabName == 3) {
      this.tabNameSelected = 'Corporate'
    }
    if (this.tabName == 4) {
      this.tabNameSelected = 'SI'
    }
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(index)
      that.pageCounter = 0
    })
    if (this.entitiesType === 'requester') {
      this.type = 0
      this.role = 1
      this.entityType = 0
    } else if (this.entitiesType === 'responder') {
      this.type = 1
      this.role = 0
      this.entityType = 2
    }
    this.pageCounter = 0
    this.onRefresh()

  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    // role () {
    //   this.getMessageRouting()
    // },
    // type () {
    //   this.getMessageRouting()
    // }
  },
  methods: {
    addMessageRouting () {
      loadPage(this, {url: '/routing/messageDetails/create/' + this.role + '/' + this.type + '/' + this.entitiesType + '/' + this.tabNameSelected})
    },
    addImportReferentiel () {
      loadPage(this, {url: '/routing/messageDetails/import/'+ this.entitiesType})
    },
    getMessageRouting () {
      let params = {
        Role: this.role,
        Type: this.type,
        entityType: this.entityType
      }
      if (this.entitiesType === 'rvm'){
        params.rvm = '1'
      }
      let that = this
      this.$engine.routing.message.fetch(
        params, this.paginationObject.firstIndex, this.paginationObject.maxResults
      ).then(resp => {
        let messageRouting = {}

        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        // Group by ReceiverId, RoutingName, and RoutingDescription
        const grouped = messageRouting.reduce((acc, item) => {
          const key = `${item.ReceiverId}-${item.RoutingName}-${item.RoutingDescription}`
          if (!acc[key]) {
            acc[key] = {
              ReceiverId: item.ReceiverId,
              RoutingName: item.RoutingName,
              RoutingDescription: item.RoutingDescription,
              CertIdentifier: item.CertIdentifier,
              Configs: [],
            }
            if(item.IdConfigInput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting})
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting})
            }

          }
          else {
            if(item.IdConfigInput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting})
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting})
            }
          }
          return acc
        }, {})

        const results = Object.values(grouped)

        this.messageRoutingIn = results
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.refreshItems()

      this.$f7.pullToRefreshDone()
    },
    getConfiguration (entitiesType) {
      if (this.entitiesType === 'rvm' && entitiesType === 'requester'){
        loadPage(this, {url: '/routing/configlist/1/' + this.type + '/' + this.entitiesType})
      }
      else if (this.entitiesType === 'rvm' && entitiesType === 'responder'){
        loadPage(this, {url: '/routing/configlist/0/' + this.type + '/' + this.entitiesType})
      }else{
        loadPage(this, {url: '/routing/configlist/' + this.role + '/' + this.type + '/' + entitiesType})
      }
    },
    getConfigurationS3 (messageType, entityType, type = 'S3') {
      if(type == "S3"){
        loadPage(this, {url: '/routing/configS3list/' + messageType + '/' + entityType})
      }
      else{
        loadPage(this, {url: '/routing/configS3/webservice/details'})
      }
    },
    refreshItems () {
      let params = {
        Role: this.role,
        Type: this.type,
        entityType: this.entityType
      }
      if (this.entitiesType === 'rvm'){
        params.rvm = '1'
      }
      if (this.entitiesType === 'decentralised'){
        params.Role = '0'
        params.entityType = '1'
        params.messageType = '2'
        params.decentralised = '1'
      }
      let that = this
      this.$engine.routing.message.fetch(
        params
      ).then(resp => {
        let messageRouting = {}

        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        // Group by ReceiverId, RoutingName, and RoutingDescription
        const grouped = messageRouting.reduce((acc, item) => {
          const key = `${item.ReceiverId}-${item.RoutingName}-${item.RoutingDescription}`
          if (!acc[key]) {
            acc[key] = {
              ReceiverId: item.ReceiverId,
              RoutingName: item.RoutingName,
              MemberId: item.MemberId,
              AcceptableErrorThreshold: item.AcceptableErrorThreshold,
              MessageType: item.MessageType,
              RoutingType: item.RoutingType,
              RoutingDescription: item.RoutingDescription,
              CertIdentifier: item.CertIdentifier,
              HeaderValue: item.HeaderValue,
              CorporateIdentifierType: item.corporateIdentifierType,
              IdAccount: item.IdAccount,
              Role: item.Role,
              Active: item.Active,
              Type: item.Type,
              Configs: [
              ]
            }

            if(item.IdConfigInput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting})
            } else {
              acc[key].Configs.push({ConfigName: '',ConfigType: 'NULL', IdConfig: '', IdMessageRouting: ''})
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting})
            } else {
              acc[key].Configs.push({ConfigName: '',ConfigType: item.ConfigType, IdConfig: '', IdMessageRouting: ''})
            }

          }
          else {
            if(item.IdConfigInput != ''){
              acc[key].Configs[0] = {ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting}
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs[1] = {ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting}
            }
          }
          return acc
        }, {})

        let results = Object.values(grouped)

        let firstIndex = that.paginationObject.firstIndex
        let maxResults = that.paginationObject.maxResults

        if (firstIndex > results.length) {
          firstIndex = 0
        } else if (firstIndex > 0) {
          firstIndex -= 1
        }

        results = results.slice(firstIndex, firstIndex + maxResults)

        this.messageRoutingIn = results
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeDetails (items) {
      let message = items[0]
      this.$engine.routing.message.clickedMessage = message
      loadPage(this, {url: '/routing/messageDetails/details/' + message.Role + '/' + message.Type + '/' + this.entitiesType +'/' + this.tabName})
    }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 85px;
  }
}
</style>
